import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'No tengo experiencia con la tecnología, ¿podré seguir el programa?',
  answer: '¡Sí! El programa incluye 30 videos paso a paso donde te mostramos exactamente dónde hacer clic. Si llegas a tener una dificultad, la resolvemos juntos compartiendo pantalla en las consultorías en vivo. Más del 95% de los alumnos comenzó sin conocimientos previos y logró avanzar; tú también puedes.'
}, {
  question: '¿Tengo que grabar videos, tener seguidores en Instagram o una marca personal para vender?',
  answer: 'Para nada. Aprenderás a vender con anuncios del producto que elijas, sin conocimientos previos ni marca personal. No necesitas mostrar tu rostro, tener seguidores ni crear contenido todos los días.'
}, {
  question: 'Ya compré otros cursos y no recibí apoyo. ¿Aquí hay soporte real?',
  answer: 'Sí, el acompañamiento es uno de nuestros pilares. Con la Consultoría Grupal tienes llamadas en vivo todas las semanas para resolver dudas y continuar avanzando.'
}, {
  question: '¿Qué pasa si no tengo ninguna idea para escribir un ebook?',
  answer: 'No necesitas ser experto. Te damos las instrucciones exactas para que la inteligencia artificial te ayude a elegir un nicho rentable, estructurar el contenido y crear tu producto en 48 horas.'
}, {
  question: 'Trabajo todo el día, ¿tendré tiempo para avanzar?',
  answer: '¡Sí! El curso está grabado para que avances a tu propio ritmo. La inteligencia artificial y nuestras plantillas simplifican el proceso, por lo que puedes trabajar en tus momentos libres. Las consultorías en vivo también quedan grabadas para que puedas verlas después.'
}, {
  question: '¿Qué incluye exactamente el acceso de USD 37?',
  answer: 'Incluye el programa completo grabado paso a paso, consultorías grupales semanales en vivo para resolver dudas y todos los bonos exclusivos de regalo.'
}, {
  question: '¿Cómo recibo el dinero de mis ventas en mi país?',
  answer: 'Te enseñamos a integrar tu tienda con pasarelas de pago disponibles en tu país para recibir el dinero de tus ventas de forma segura.'
}, {
  question: 'Además del acceso al programa, ¿tengo que realizar otra inversión?',
  answer: 'Necesitarás el plan básico de Shopify y un presupuesto para publicidad. Puedes comenzar probando tu primera campaña con aproximadamente USD 25 y reinvertir una parte de las ganancias generadas.'
}, {
  question: '¿En cuánto tiempo veré resultados?',
  answer: 'Si aplicas el paso a paso, en 72 horas puedes tener tu ebook listo. Muchos alumnos logran sus primeras ventas durante los primeros días de sus anuncios. Los resultados dependen de tu constancia y compromiso.'
}, {
  question: 'Me preocupa que no funcione para mí, ¿tiene garantía?',
  answer: 'Tienes una garantía incondicional de 14 días. Si ingresas y sientes que el programa no es para ti, puedes solicitar la devolución y te reintegramos el 100% de tu dinero.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-20 px-4 bg-[#121212] pt-[0px] pb-[0px]" data-id="element-77" data-mp="166gxlnn40fy1">
      <div className="max-w-3xl mx-auto" data-id="element-78" data-mp="22u3pd898na55">
        <div className="text-center mb-12" data-id="element-79" data-mp="22x9dola1m7zt">
          <h2 className="text-3xl md:text-5xl font-black leading-tight text-[#FFFFFF]" data-id="element-80" data-mp="1ytbfccsjl17t">
            ❓LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-81" data-mp="1u0qnhgt74y6x">
          {faqs.map((faq, index) => <div key={index} className="bg-[#000000] rounded-xl border border-gray-700 overflow-hidden shadow-sm" data-id="element-82" data-mp="1p38nifx5ptb2" data-mpi={index}>
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left gap-4 hover:bg-[#1a1a1a] transition-colors bg-[#000000]" data-id="element-83" data-mp="2hrw43y6ynuia">
                <span className="text-base md:text-lg font-[500] font-[Inter,_sans-serif] text-[#FFFFFF]" data-id="element-84" data-mp="26csua4y4nmrp">
                  {index + 1}. {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#9C16A3] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-85" data-mp="1xajjddyy5rds" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 bg-[#000000] ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-86" data-mp="2p17iylkz2opc">
                <p className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-87" data-mp="2g95nz2toa0mg">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}